import React from "react";
import CartItem from "./components/CartItem";
import CheckoutForm from "./components/CheckoutForm";
import PriceDetails from "./components/PriceDetails";
import { useTranslation } from "react-i18next";
import { UiTitle } from "../../components/text/UiTitle";

const CartPage: React.FC = () => {
  const handleFormSubmit = (data: any) => {};
  const { t } = useTranslation();
  return (
    <div className="container mx-auto grid grid-cols-3 gap-4 p-4">
      {/* Danh sách sản phẩm */}
      <div className="col-span-2">
        <UiTitle text={t("Ordered Product")} />
        <CartItem
          title="New York City Pass"
          adultPrice={100}
          childPrice={50}
          adultQty={2}
          childQty={1}
          totalPrice={250}
        />
        <CartItem
          title="Musical Name"
          adultPrice={150}
          childPrice={75}
          adultQty={2}
          childQty={1}
          totalPrice={300}
        />
      </div>

      {/* Thông tin khách hàng và giá */}
      <div>
        <h2 className="text-xl font-bold">{t("Information")}</h2>
        <CheckoutForm onSubmit={handleFormSubmit} />
        <h2 className="mt-4 text-xl font-bold">{t("Price Details")}</h2>
        <PriceDetails subtotal={550} discount={50} vat={0} total={500} />
      </div>
    </div>
  );
};

export default CartPage;
